<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <user-field-group-edit-form
        @on-submit="onUserFieldGroupEditSubmit"
      ></user-field-group-edit-form>
    </div>
    <div
      v-if="this.$route.params.id !== undefined"
      class="md-layout-item md-size-100"
    >
      <user-fields-by-group-overview></user-fields-by-group-overview>
    </div>
    <div
      v-if="this.$route.params.id !== undefined"
      class="md-layout-item md-size-100 text-right"
    >
      <md-button
        native-type="button"
        @click.native.prevent="handleAdd"
        class="md-success"
        >Veld toevoegen</md-button
      >
    </div>
  </div>
</template>
<script>
import UserFieldGroupEditForm from "./UserFieldGroupEditForm.vue";
import UserFieldsByGroupOverview from "./UserFieldsByGroupOverview.vue";

export default {
  components: {
    UserFieldGroupEditForm,
    UserFieldsByGroupOverview
  },
  data() {
    return {
      userFieldGroupEditModel: {}
    };
  },
  computed: {
    isDriverField: function() {
      if (this.$route.fullPath.indexOf("driver_field_groups") >= 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleAdd() {
      this.$router.push(
        (this.isDriverField
          ? "/driver_field_groups/group/"
          : "/user_field_groups/group/") +
          this.$route.params.id +
          "/field/add"
      );
    },
    onUserFieldGroupEditSubmit(model) {
      this.userFieldGroupEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'users/field/group/' + this.userFieldGroupEditModel.id, Object.assign(this.userFieldGroupEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
